export const franchiseSteps = [
  {
    title: "ফ্র্যাঞ্চাইজি পার্টনারশিপ শুরু",
    benefits: [
      "QS Smart School ব্র্যান্ড নাম ব্যবহার",
      "Franchising Agreement ও ব্র্যান্ড অনুমোদন",
      "লোকেশন নির্বাচন ও অনুমোদন সহায়তা",
      "নথিপত্র ও কনসালটেন্সি সাপোর্ট",
    ],
  },
  {
    title: "স্কুল অবকাঠামো ও ডিজাইন সাপোর্ট",
    benefits: [
      "স্কুল বিল্ডিং বা শ্রেণিকক্ষের নকশা (Interior Design/Layout Plan)",
      "প্রি-স্কুল, প্রাইমারি ও হাইস্কুলের কক্ষ বিন্যাস পরামর্শ",
      "Child-friendly, smart & inclusive learning environment ডিজাইন",
      "স্কুলের সাইনবোর্ড, ইউনিফর্ম, লোগো, ওয়াল ডিজাইন টেমপ্লেট",
    ],
  },
  {
    title: "শিক্ষক ও স্টাফ ট্রেনিং",
    benefits: [
      "Outcome Based Education (OBE) Teacher Training",
      "Lesson Plan, SLOs, Rubric Design প্রশিক্ষণ",
      "Soft skills & Classroom Management প্রশিক্ষণ",
      "হেডটিচার ও অ্যাডমিন ট্রেনিং",
      "প্রশিক্ষণের শেষে সার্টিফিকেট প্রদান",
    ],
  },
  {
    title: "কারিকুলাম ও একাডেমিক সাপোর্ট",
    benefits: [
      "বাংলা ও ইংরেজি ভার্সনের OBE-aligned কারিকুলাম",
      "Outcome-based Lesson Plan, Assessment Plan",
      "বার্ষিক পাঠ পরিকল্পনা (Academic Calendar + Weekly Planner)",
      " Rubrics",
      "Technology Integration (Smart Learning Tools, Apps)",
    ],
  },
  {
    title: "সফটওয়্যার ও ডিজিটাল সাপোর্ট",
    benefits: [
      "QS Digital School Management Software (ERP)",
      "Attendance, Exam, Billing, Result, Communication সিস্টেম",
      "Teacher & Parent Mobile App access",
      "Learning Management System (LMS) সাপোর্ট",
      "Zoom/Google Classroom Integration",
    ],
  },
  {
    title: "মার্কেটিং ও ব্র্যান্ডিং সাপোর্ট",
    benefits: [
      "স্কুল উদ্বোধনের জন্য উদ্বোধনী কিট (Invitation, Banner, Promo)",
      "ডিজিটাল মার্কেটিং কনটেন্ট (পোস্টার, ভিডিও, বিজ্ঞাপন)",
      "Social Media Promotion Template & Support",
      "Parent Orientation Program Kit",
      "Admission Campaign Guide",
    ],
  },
  {
    title: "নিয়মিত মনিটরিং ও উন্নয়ন",
    benefits: [
      "প্রতি মাসে Academic Monitoring & Evaluation",
      "Performance Audit (Teacher & Student)",
      "Continuous Teacher Development (CTD Program)",
      "Parent Satisfaction Survey Tools",
      "Annual School Improvement Planning (SIP) সহায়তা",
    ],
  },
  {
    title: "সার্টিফিকেশন ও অংশগ্রহণ",
    benefits: [
      "QS Smart School ব্র্যান্ড সার্টিফিকেট",
      "Annual National Smart School Conference–এ অংশগ্রহণ",
      "শিক্ষার্থী, শিক্ষক ও প্রতিষ্ঠানিক পুরস্কার প্রাপ্তির সুযোগ",
      "QS Academy-এর অন্যান্য প্রজেক্ট ও মেলা/ইভেন্টে অংশগ্রহণ",
    ],
  },
];



export const qsSmartSchoolFranchiseData = [
  {
    id: 1,
    header: "QS Smart School Franchise কী?",
    text: [
      "QS Smart School Franchise হলো একটি আধুনিক স্কুল পরিচালনার মডেল, যেখানে ডিজিটাল টুলস, স্মার্ট ক্লাসরুম, দক্ষ শিক্ষক প্রশিক্ষণ এবং ব্যক্তিকেন্দ্রিক শিক্ষাপদ্ধতির মাধ্যমে শিশুর সার্বিক বিকাশ নিশ্চিত করা হয়।",
    ],
  },
  {
    id: 2,
    header: "আমি কীভাবে QS Smart School-এর ফ্র্যাঞ্চাইজি নিতে পারি?",
    text: [
      "আপনাকে QS Academy-এর অফিসিয়াল ওয়েবসাইট বা প্রতিনিধি মাধ্যমে আবেদন করতে হবে। যাচাই-বাছাই শেষে, আপনার এলাকা ও অবকাঠামোর ভিত্তিতে চুক্তি করা হয়।",
    ],
  },
  {
    id: 3,
    header: "QS Smart School Franchise নিতে হলে কী কী যোগ্যতা প্রয়োজন?",
    text: [
      "শিক্ষার প্রতি আগ্রহ",
      "নিজস্ব বা ভাড়াকৃত ভবন",
      "৫–৭ কক্ষবিশিষ্ট ইনফ্রাস্ট্রাকচার",
      "প্রাথমিক বিনিয়োগ সক্ষমতা",
      "শিশুদের ভবিষ্যৎ গড়ার দৃষ্টিভঙ্গি",
    ],
  },
  {
    id: 4,
    header: "QS Academy থেকে কী ধরণের সাপোর্ট দেওয়া হয়?",
    text: [
      "সম্পূর্ণ কারিকুলাম ও সিলেবাস",
      "শিক্ষক প্রশিক্ষণ ও ওয়ার্কশপ",
      "ডিজিটাল ক্লাসরুম সেটআপ গাইড",
      "মার্কেটিং ও ব্র্যান্ডিং সাপোর্ট",
      "Parent Communication App",
      "মাসিক একাডেমিক মনিটরিং",
    ],
  },
  {
    id: 5,
    header: "QS Smart School অন্য সাধারণ স্কুল থেকে কীভাবে আলাদা?",
    text: [
      "QS Smart School শুধু পাঠ্যবই নয় — এটি Thought Mapping, Mind Mapping, Wellness Test, Skill Development & Brain-Based Learning ব্যবহারের মাধ্যমে শিশুকে স্মার্ট নাগরিক হিসেবে গড়ে তোলে।",
    ],
  },
  {
    id: 6,
    header: "এই ফ্র্যাঞ্চাইজির জন্য কী পরিমাণ বিনিয়োগ প্রয়োজন?",
    text: [
      "বিনিয়োগের পরিমাণ অবস্থান, ভবনের আকার, ক্লাস সংখ্যা ও সুবিধা অনুসারে পরিবর্তিত হয়। সাধারণত ৫ লাখ থেকে ১৫ লাখ টাকার মধ্যে একটি স্ট্যান্ডার্ড QS Smart School চালু করা সম্ভব।",
    ],
  },
  {
    id: 7,
    header: "QS Franchise-এর বিনিয়োগ কাঠামো কেমন?",
    text: [
      "বিনিয়োগের পরিমাণ নির্ভর করে অবস্থান ও পরিকাঠামোর ওপর। সাধারণত ৫–১৫ লাখ টাকার মধ্যে একটি পূর্ণাঙ্গ QS Smart School চালু করা সম্ভব।",
    ],
  },
  {
    id: 8,
    header: "QS Smart School কি শহরের বাইরেও চালু করা যায়?",
    text: [
      "অবশ্যই। QS Academy শহর, উপজেলা এবং গ্রামীণ এলাকায় শিক্ষার মান উন্নয়নের লক্ষ্যে ফ্র্যাঞ্চাইজি দিচ্ছে।",
    ],
  },
  {
    id: 9,
    header: "QS Smart School-এ শিক্ষক নিয়োগ ও প্রশিক্ষণ কীভাবে হয়?",
    text: [
      "QS Academy নিয়মিতভাবে শিক্ষক প্রশিক্ষণ প্রোগ্রাম পরিচালনা করে, যাতে শিক্ষকরা শিশুদের সঙ্গে আধুনিক ও কার্যকর পদ্ধতিতে পড়াতে পারেন।",
    ],
  },
  {
    id: 10,
    header: "অভিভাবকেরা কীভাবে সন্তানের অগ্রগতি পর্যবেক্ষণ করবেন?",
    text: [
      "QS Smart School-এর Parent App-এর মাধ্যমে অভিভাবকরা সন্তানের উপস্থিতি, ফলাফল, হোমওয়ার্ক ও শিক্ষকদের মন্তব্য সহজেই দেখতে পারেন।",
    ],
  },
];